/* About page partners (sections/about-partners): tap or Enter/Space on a card opens its story (hover does the same
   with a mouse, in CSS); tapping the open story or pressing Escape closes it. Group filter chips show one group. */
(() => {
  const root = document.querySelector('[data-about-partners]');
  if (!root) return;

  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    const btn = item.querySelector('.about-partner__card');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const closeAll = (except) => root.querySelectorAll('.about-partner.is-open').forEach((i) => { if (i !== except) setOpen(i, false); });

  root.addEventListener('click', (e) => {
    const card = e.target.closest('.about-partner__card');
    if (card) {
      const item = card.closest('.about-partner');
      const open = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, open);
      return;
    }
    const story = e.target.closest('.about-partner__story');
    if (story && !e.target.closest('a')) {
      const item = story.closest('.about-partner');
      setOpen(item, false);
      item.querySelector('.about-partner__card').focus();
      return;
    }
    const chip = e.target.closest('[data-partner-filter]');
    if (chip) {
      const g = chip.dataset.partnerFilter;
      root.querySelectorAll('[data-partner-filter]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      closeAll();
      root.querySelectorAll('.about-partner:not(.about-partner--join)').forEach((i) => { i.hidden = !!g && i.dataset.partnerGroup !== g; });
    }
  });

  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const item = e.target.closest('.about-partner.is-open');
    if (item) { setOpen(item, false); item.querySelector('.about-partner__card').focus(); }
  });
})();
